import config from "../configuration/config";

const basePath = process.env.PUBLIC_URL || "";
const redirectUri = `${window.location.origin}${basePath}/`.replace(/\/+$/, "/");

export const msalConfig = {
  auth: {
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const apiTokenRequest = {
  scopes: [config.apiScope],
};